import { Heading1 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import {
  color,
  container,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing
} from 'theme';

export const StyledHero = styled.div`
  padding: ${spacing('xl4')} ${spacing('md')};
  position: relative;
  background-color: ${color('sun_100')};

  @media (min-width: ${screen('md')}) {
    padding-top: ${spacing('xl5')};
    padding-bottom: ${spacing('xl5')};
  }
`;

export const StyledHeroContainer = styled.div`
  max-width: ${container('xlMax')};
  margin: auto;
  color: ${color('text_white')};
  font-size: ${fontSize('lg')};
  line-height: 1.4;
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing('md')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
  }
`;

export const StyledHeroImage = styled.img`
  @media (min-width: ${screen('md')}) {
    max-width: 25rem;
  }
  @media (min-width: ${screen('xl')}) {
    max-width: 34rem;
  }
`;

export const StyledHeroContent = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  color: var(--headingColor);
`;

export const StyledHeroTitle = styled(Heading1)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing('xs')};
  font-family: ${fontFamily('sans')};
  margin-bottom: ${spacing('md')};

  &::before {
    background-color: var(--headingColor);
    height: ${spacing('xs')};
    top: calc(${spacing('lg')} * -1);
  }
`;

export const StyledHeroDesc = styled.p`
  font-size: ${fontSize('md')};
  line-height: 1.5;
  max-width: ${container('lg')};
  margin: 0 auto;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.6;
  }
`;

export const StyledData = styled.div`
  margin-top: ${spacing('xl4')};
`;

export const StyledDataTitle = styled.h4`
  font-family: ${fontFamily('sans')};
  font-size: ${fontSize('lg')};
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: 0.35em;
  margin-top: 0;
  font-weight: ${fontWeight('black')};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing('xs')};

  &::before,
  &::after {
    content: '';
    height: 1px;
    background-color: ${color('white')};
    flex-grow: 1;
  }

  &::before {
    @media (max-width: ${screen('mdMax')}) {
      display: none;
    }
  }
`;
